import type { IOrder } from '@/models/orders';
import type { IPayment } from '@/models/payments';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ModelDebiCheckRequest, ModelMerchantResponse } from '@layup/api-sdk';
import type { IPaymentPlan, IPaymentPlanPreview } from '../models/paymentPlans';
import { getMerchant } from '../services/merchants';

export const useWidgetStore = defineStore('widget', {
  state: () => {
    /*
    Specific store values for each product.
    Only needed until the order is created.
    */
    const layby = ref({
      billingDay: 0,
      duration: 0,
    });
    const boost = ref({
      merchant: {} as ModelMerchantResponse,
      newBoost: {
        deposit: 0,
        duration: 0,
        savingsGoal: 0,
        billingDay: 0,
      },
      partialOrder: {} as Partial<IOrder>,
    });

    // Common to all widget flows
    const paymentPlanPreview = ref({} as IPaymentPlanPreview);
    const order = ref({} as IOrder);
    const plan = ref({} as IPaymentPlan);
    const mandateRequest = ref<ModelDebiCheckRequest | null>({});
    const payAtReference = ref('');
    const amountDue = ref(0);
    const id = ref('');
    const successfulPayment = ref({} as IPayment);
    const notifyUrl = ref('');

    return {
      layby,
      boost,
      order,
      mandateRequest,
      plan,
      paymentPlanPreview,
      payAtReference,
      amountDue,
      id,
      successfulPayment,
      notifyUrl,
    };
  },
  actions: {
    getPaymentPlan(): IPaymentPlan {
      return this.order.plans?.[0] || ({} as IPaymentPlan);
    },
    async getBoostMerchant(merchantId: string) {
      if (!this.boost.merchant || this.boost.merchant._id !== merchantId) {
        this.boost.merchant = await getMerchant(merchantId);
      }
      return this.boost.merchant;
    },
    reset() {
      this.$reset();
    },
  },
  persist: true,
});
